function callBrowserCanUseArrowFunctions() {
	let result;
	try {
		result = window.browserCanUseArrowFunctions();
	} catch (e) {
		result = false;
	}
	return result;
}

if (
	!('Promise' in window && 'resolve' in window.Promise && 'reject' in window.Promise && 'all' in window.Promise) ||
	!('fetch' in window) ||
	!('IntersectionObserver' in window) ||
	!callBrowserCanUseArrowFunctions()
) {
	const e = document.getElementById('browser-check');
	e.style.display = '';
	e.classList.remove('display-none');
}
